import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Award } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getBackendUrl } from '../utils/getBackendUrl';

const API = `${getBackendUrl()}/api`;

const COLOR = {
  amber:   'bg-amber-100 text-amber-800 border-amber-200',
  blue:    'bg-blue-100 text-blue-800 border-blue-200',
  indigo:  'bg-indigo-100 text-indigo-800 border-indigo-200',
  purple:  'bg-purple-100 text-purple-800 border-purple-200',
  rose:    'bg-rose-100 text-rose-800 border-rose-200',
  emerald: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  red:     'bg-red-100 text-red-800 border-red-200',
  cyan:    'bg-cyan-100 text-cyan-800 border-cyan-200',
};

export default function MyBadgesWidget() {
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/badges/my`)
      .then((r) => setBadges(Array.isArray(r.data) ? r.data : []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-4" data-testid="my-badges-widget">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-yellow-500" />
          <h3 className="font-bold text-gray-900">My Badges</h3>
          {!loading && (
            <span className="text-xs font-semibold text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">
              {badges.length}
            </span>
          )}
        </div>
        <Link to="/leaderboard" className="text-xs font-bold text-blue-600 hover:text-blue-700">
          Leaderboard →
        </Link>
      </div>

      {loading ? (
        <p className="text-center text-sm text-gray-400 py-4">Loading…</p>
      ) : badges.length === 0 ? (
        <div className="text-center py-6">
          <Award className="w-10 h-10 text-gray-200 mx-auto mb-2" />
          <p className="text-sm text-gray-500">No badges yet — keep working and they'll start to roll in.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-2">
          {badges.map((b) => (
            <div
              key={b.slug}
              className={`rounded-lg border p-2.5 flex items-start gap-2 ${COLOR[b.color] || 'bg-gray-100 text-gray-700 border-gray-200'}`}
              title={b.desc}
              data-testid={`my-badge-${b.slug}`}
            >
              <span className="text-2xl leading-none flex-shrink-0">{b.icon}</span>
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold leading-tight">{b.label}</p>
                <p className="text-[10px] opacity-80 line-clamp-2 mt-0.5">{b.desc}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
